export const FETCH_SPACE_DATA = 'FETCH_SPACE_DATA';
export const FETCH_SPACE_DATA_SUCCESS = 'FETCH_SPACE_DATA_SUCCESS';
export const FETCH_SPACE_DATA_FAILS = 'FETCH_SPACE_DATA_FAILS';


export const FETCH_REVIEW_DATA = 'FETCH_REVIEW_DATA';
export const FETCH_REVIEW_DATA_SUCCESS = 'FETCH_REVIEW_DATA_SUCCESS';
export const FETCH_REVIEW_DATA_FAILS = 'FETCH_REVIEW_DATA_FAILS';

export const FETCH_USER_DATA = 'FETCH_USER_DATA';
export const FETCH_USER_DATA_SUCCESS = 'FETCH_USER_DATA_SUCCESS';
export const FETCH_USER_DATA_FAILS = 'FETCH_USER_DATA_FAILS';

export const ADD_REVIEW = 'ADD_REVIEW';
export const ADD_REVIEW_SUCCESS = 'ADD_REVIEW_SUCCESS';
export const ADD_REVIEW_FAILS = 'ADD_REVIEW_FAILS';

export const UPDATE_REVIEW = 'UPDATE_REVIEW';
export const UPDATE_REVIEW_SUCCESS = 'UPDATE_REVIEW_SUCCESS';
export const UPDATE_REVIEW_FAILS = 'UPDATE_REVIEW_FAILS';

export const DELETE_REVIEW = 'DELETE_REVIEW';
export const DELETE_REVIEW_SUCCESS = 'DELETE_REVIEW_SUCCESS';
export const DELETE_REVIEW_FAILS = 'DELETE_REVIEW_FAILS';

export const CLEAR_REVIEW_DETAILS = 'CLEAR_REVIEW_DETAILS';
